import { useContext } from "react";
import { ThemeContext } from "@emotion/react";
import Paper from '@mui/material/Paper';
import { GroupingTable } from "../../../components/Table/grouping_table";

export const TablaDefectivos = ({ sample, clickEdit }) => {

  const theme = useContext(ThemeContext);
  const sort = {}

  const columns = [
    {
      accessorFn: (row) => row.almacenes?.alma_nombre || '',
      id: 'almacen',
      header: 'Almacen',
      sortingFn: 'text',
      filterFn: 'includesString',
    },
    {
      accessorKey: 'def_codigo',
      header: 'Código',
    },
    {
      accessorKey: 'def_defecto',
      header: 'Defecto',
    },
    {
      accessorFn: (row) => row.def_status ? 'Activo' : 'Inactivo',
      id: 'estatus',
      header: 'Estatus',
      sortingFn: 'text',
      filterFn: 'includesString',
    }
  ]
  const rows = sample;


  return (
    <Paper style={{ height: '100%', width: '100%' }} sx={{ boxShadow: 'none' }}>
      <GroupingTable key='table_partes' columnas={columns} data={rows} sort={sort} redirect={clickEdit} />
    </Paper>
  )
}